'use strict';

export const wrapper = '<span class="%ROOT%"></span>';
export const dropdown = '<span class="%PREFIX%%DROPDOWN_MENU%"></span>';
export const dataset = '<div class="%PREFIX%%DATASET%-%CLASS%"></div>';
export const suggestions = '<span class="%PREFIX%%SUGGESTIONS%"></span>';
export const suggestion = '<div class="%PREFIX%%SUGGESTION%"></div>';
